/**
 * Contacts — couche API (page V2 « Contacts »)
 *
 * Liste paginée des contacts (non archivés), recherche contact-only côté serveur
 * (PAS l'omnisearch global). S'appuie sur `GET /contacts/list` (boostcore),
 * qui déduplique la cohabitation Odoo v16/v18 selon la source de l'user.
 */
import { apiFetch } from '@/auth/apiFetch'

export interface ContactListItem {
  uuid: string
  firstname: string | null
  lastname: string | null
  email: string | null
  phone: string | null
  mobile: string | null
  company: { uuid: string; name: string | null; currentStatus: string | null } | null
}

export interface ContactListResponse {
  data: ContactListItem[]
  total: number
}

export type ContactSortField = 'lastname' | 'firstname' | 'email'
export type SortOrder = 'asc' | 'desc'

function qs(params: Record<string, unknown>): string {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  if (!entries.length) return ''
  const usp = new URLSearchParams()
  for (const [k, v] of entries) usp.set(k, String(v))
  return `?${usp.toString()}`
}

async function json<T>(res: Response): Promise<T> {
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`)
  if (res.status === 204) return undefined as unknown as T
  return (await res.json()) as T
}

export function listContacts(params: {
  q?: string
  limit: number
  offset: number
  sort: ContactSortField
  order: SortOrder
  signal?: AbortSignal
}): Promise<ContactListResponse> {
  const { q, limit, offset, sort, order, signal } = params
  return apiFetch(`/contacts/list${qs({ q, limit, offset, sort, order })}`, { signal }).then(
    json<ContactListResponse>,
  )
}
